var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsString, MaxLength } from 'class-validator';
/**
 * Refusal code of the TAN exchange for every TAN that gets nobody in: unknown,
 * expired, deleted or mistyped (#1855). One answer whatever the reason.
 */
export const TAN_INVALID = 'TAN_INVALID';
/** Refusal code once an address or everyone has used up the failed attempts (#1855). */
export const CALL_SESSION_RATE_LIMITED = 'RATE_LIMITED';
/** `POST /auth/call-session`: the TAN as the patient typed it, dash and case don't matter. */
export class CallSessionExchangeDto {
    tan;
}
__decorate([
    Expose(),
    IsString(),
    MaxLength(32),
    __metadata("design:type", String)
], CallSessionExchangeDto.prototype, "tan", void 0);
/**
 * The call token a TAN is exchanged for (#1855). It is sent in
 * `X-Therame-Call-Session`, reaches only `@AccessibleWithTan` endpoints and
 * only its own call, and expires with the TAN; there is no refresh.
 */
export class CallSessionDto {
    token;
    /** ISO timestamp: the TAN's expiry. */
    expiresAt;
    callId;
    /** The call's patient, the Person the session acts as. */
    patientId;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], CallSessionDto.prototype, "token", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CallSessionDto.prototype, "expiresAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CallSessionDto.prototype, "callId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], CallSessionDto.prototype, "patientId", void 0);
//# sourceMappingURL=call-session.js.map